import { render, staticRenderFns } from "./TermsPersonalKT.vue?vue&type=template&id=b975d312&scoped=true&"
var script = {}
import style0 from "./TermsPersonalKT.vue?vue&type=style&index=0&id=b975d312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b975d312",
  null
  
)

export default component.exports